<template>
    <div class="vue-modal-wrapper">
        <button class="close-button mt-1" @click="handleClose">
            <span class="visually-hidden">{{ closeText }}</span>
        </button>

        <template v-if="!isExtraCountry">
            <div class="content-wrapper">
                <h3>{{ item.name }}</h3>
                <p v-if="item.shops > 0">{{ shopsText }} {{ item.shops }}</p>
            </div>

            <div class="to-site-button-wrapper">
                <a :href="item.url" class="btn-primary to-site-button">{{ goToSiteText }}</a>
            </div>
        </template>

        <template v-if="isExtraCountry">
            <div class="content-wrapper">
                <h3>NexDrive {{ extraCountryName }}</h3>
                <p v-if="!customWebsite">{{ notAvailableText }}</p>
            </div>

            <div class="to-site-button-wrapper">
                <a v-if="customWebsite" :href="customWebsite" class="btn-primary to-site-button">{{ goToSiteText }}</a>
                <button v-if="!customWebsite" @click="handleClose" class="btn-primary to-site-button">{{ closeText }}</button>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: "ModalWrapper",

    props: {
        item: {
            type: Object,
        },
        extraCountryName: {
            type: String,
        },
        isExtraCountry: {
            type: Boolean,
            default: false,
        },
        customWebsite: {
            type: String
        }
    },

    data() {
        return {
            closeText: window.Drupal.t('Close'),
            shopsText: window.Drupal.t('Shops:'),
            goToSiteText: window.Drupal.t('Go to website'),
            notAvailableText: window.Drupal.t('We will soon be available in this country, keep an eye on the website.'),
        }
    },

    methods: {
        handleClose() {
            this.$modal.close();
        },
    }
}
</script>